import stampImg from "../../img/stampp.png";
import signImg from "../../img/sign.png";
export const printCombinedDoc = (
  student,
  modulesList,
  marksArray,
  printType,
) => {
  const printWindow = window.open("", "_blank");
  const STAMP_URL = stampImg;
  const SIGNATURE_URL = signImg;
  const issueDate = new Date(
    student.issueDate || new Date(),
  ).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const totalSecured = marksArray.reduce((a, b) => a + (parseInt(b) || 0), 0);
  const totalPossible = modulesList.length * 100;
  const percentage = ((totalSecured / totalPossible) * 100).toFixed(2);
  const isCertificateOnly = printType === "certificate";
  // const verifyUrl = `https://divyacomputer.in/verify/${student.id}`;
  const verifyUrl = `${window.location.origin}/verify/${student.id}?type=${printType}`;
  // console.log("Generated verify URL:", verifyUrl, "okok", student.id);

  // Determine relationship prefix based on gender
  const relationPrefix =
    student.gender?.toLowerCase() === "male"
      ? "S/o"
      : student.gender?.toLowerCase() === "female"
        ? "D/o"
        : "Child of";

  printWindow.document.write(`
    <html>
      <head>
        <title>Certificate - ${student.full_name}</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@700&family=Montserrat:wght@400;700&display=swap');
         @page {
  size: ${isCertificateOnly ? "A4 landscape" : "A4 portrait"};
  margin: 0;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-family: 'Times New Roman', serif;
  background: #fff;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
}

.cert-outer {
  width: ${isCertificateOnly ? "297mm" : "210mm"};
  height: ${isCertificateOnly ? "210mm" : "297mm"};
  padding: 3mm;
  box-sizing: border-box;
  margin: 0 auto;
}
          .cert-container { width: 100%; height: 100%; border: 6px double #8b5e3c; padding: 12mm; background: #fffdf0; box-sizing: border-box; position: relative; display: flex; flex-direction: column; overflow: hidden; }
          
          /* Watermark */
          .watermark { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(-30deg); font-size: 55px; color: rgba(139, 94, 60, 0.03); font-family: 'Cinzel', serif; white-space: nowrap; z-index: 0; pointer-events: none; text-align: center; line-height: 1.5; width: 150%; }
          
          .content-wrapper { position: relative; z-index: 1; flex-grow: 1; display: flex; flex-direction: column; }
          
          /* Straight Header */
          .inst-name-straight { font-family: 'Cinzel', serif; font-size:30px; color: #7c2d12; text-align: center; margin: 6px 0 3px 0; font-weight: 900; letter-spacing: 1px; }
          
          .badge-text { display: inline-block; background: #ea580c; color: white; padding: 4px 20px; border-radius: 50px; font-weight: bold; font-size: 13px; margin: 5px auto; font-family: 'Montserrat', sans-serif; text-transform: uppercase; }
          
          .photo-box { position: absolute; top: 110px; left: 0; width: 110px; height: 135px; border: 2px solid #8b5e3c; background: #fff; display: flex; align-items: center; justify-content: center; font-size: 10px; color: #8b5e3c; font-weight: bold; }
          
        .course-title {
  font-family: 'Cinzel', serif;
  color: #ea580c;
  font-size: 15px;   /* reduced */
  margin: 6px;     /* less spacing */
  font-weight: bold;
  text-align: center;
  word-break: break-word;
  line-height: 1.3;
}
          .content-text { text-align: center; font-size: 15px; line-height: 1.5; margin: 8px 20px 20px 130px; color: #333; }
          .content-text b { color: #1e40af; }
          
          .info-row { display: flex; justify-content: space-between; font-weight: bold; margin: 15px 0; font-size: 14px; border-bottom: 1px solid #ddd; padding-bottom: 5px; }
          .info-row-certificate {display: flex;  flex-direction: column; justify-content: space-between; font-weight: bold; margin: 15px 0; font-size: 14px; }
                    
          .marks-table { width: 100%; border-collapse: collapse; font-size: 11.5px; border: 2px solid #333; background: white; }
          .marks-table th { background: #7c2d12; color: white; padding: 8px; text-transform: uppercase; border: 1px solid #333; }
          .marks-table td { border: 1px solid #333; padding: 0; }
          .inner-row td { padding: 6px 10px; border: none !important; border-bottom: 1px solid #eee !important; }
          
          .summary-panel { width: 195px; padding: 12px; background: #fef3c7; vertical-align: top; border-left: 2px solid #333 !important; }
          .summary-panel b { display: block; margin-bottom: 5px; color: #7c2d12; font-size: 12px; }

          /* Footer with space for Signature and Mohar */
          .footer { margin-top: auto; padding-bottom: 30px; display: flex; justify-content: space-between; align-items: flex-end; }
          .footer-certificate { margin-top: auto; padding-bottom: 55px; display: flex; justify-content: space-between; align-items: flex-end; }
          
          .seal-section { text-align: center; width: 150px; height: 100px;  display: flex; align-items: center; justify-content: center; color: #000000; font-size: 10px; font-weight: bold; border-radius: 50%; margin-left: 20px; }
          
          .sig-box { text-align: center; width: 250px; }
          .sig-space { height: 60px; } /* Blank space for physical signature */
          .sig-line { border-top: 2px solid #333; padding-top: 8px; font-weight: bold; color: #7c2d12; font-size: 16px; }

          .grade-scale { position: absolute; bottom: 15px; left: 15px; right: 15px; display: flex; font-size: 10px; font-weight: bold; text-align: center; color: white; border-radius: 4px; overflow: hidden; }
          .scale-box { flex: 1; padding: 6px; }

          /* Seal (Stamp) Adjustment */
.seal-img { 
  width: 100px;      /* Increased size */
  height: 100px; 
  margin-bottom: 5px;
  object-fit: contain; 
  z-index: 1;
}



.sig-img { 
  width: 150px;      /* Increased width for visibility */
  height: auto; 
  position: absolute; 
  bottom: 70px;      /* Adjust this to sit perfectly on the line */
  left: 85%; 
  transform: translateX(-50%); 
  z-index: 2; 
  mix-blend-mode: multiply; /* Makes white background of image transparent */
}

.sig-img-certificate { 
  width: 150px;      /* Increased width for visibility */
  height: auto; 
  position: absolute; 
  bottom: 90px;      /* Adjust this to sit perfectly on the line */
  left: 85%; 
  transform: translateX(-50%); 
  z-index: 2; 
  mix-blend-mode: multiply; /* Makes white background of image transparent */
}


.certificate-only-content {
  margin: 20px 40px 30px 160px !important;
  text-align: center !important;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 420px;
}

.certificate-only-info {
  margin-top: 25px !important;
  margin-bottom: 40px !important;
  font-size: 18px !important;
  font-weight: bold !important;
}


        </style>
      </head>
      <body>
        <div class="cert-outer">
          <div class="cert-container">
            <div class="watermark">DIVYA TECHNICAL INSTITUTE<br>DIVYA TECHNICAL INSTITUTE<br>DIVYA TECHNICAL INSTITUTE</div>
            <div class="content-wrapper">
              
              <div class="header" style="text-align:center;">
                <div style="display:flex; justify-content: space-between; font-size: 11px; font-weight: bold; color: #7c2d12;">
                  <span>Run by BSSST</span>
                  <span>Reg.No. IN-UP58033026783122W</span>
                </div>
                
                <h1 class="inst-name-straight">DIVYA TECHNICAL INSTITUTE</h1>
                
                <div style="text-align:center;">
  <div class="badge-text">
    ${
      printType === "certificate"
        ? "Certificate"
        : printType === "marksheet"
          ? "Marksheet"
          : "Certificate + Marksheet"
    }
  </div>
</div>
                <p style="font-size: 12px; margin: 5px 0; color: #666; font-weight: bold;">Vill.+Post Mardah, Distt. Ghazipur (U.P.) — 233226</p>
          ${
            !isCertificateOnly
              ? `<div class="course-title">${student.course_name || ""}</div>`
              : ""
          }
              </div>

              <div class="photo-box">
  ${
    student.photo_url
      ? `<img src="${student.photo_url}" style="width:100%; height:100%; object-fit:cover;" />`
      : `STUDENT PHOTO`
  }
</div>
   
${
  isCertificateOnly
    ? `
      <!-- =========================================
           CERTIFICATE ONLY LAYOUT (FIXED FULL PAGE)
           ========================================= -->
      <div class="content-text" style="
        text-align: center;
       margin: 3px 70px 5px 170px;
flex: 1;
display: flex;
flex-direction: column;
justify-content: center;
min-height: auto;
        color: #111827;
      ">
        <p style="
          font-size: 18px;
          margin: 0 0 18px 0;
          font-style: italic;
          font-weight: 600;
          color: #1f2937;
        ">
          This is to certify that
        </p>

        <p style="
          font-size: 32px;
          font-weight: 700;
          color: #1e40af;
          margin: 0 0 18px 0;
          line-height: 1.2;
          text-transform: uppercase;
          letter-spacing: 1px;
        ">
          ${student.full_name}
        </p>

        <p style="
          font-size: 18px;
          margin: 0 0 28px 0;
          font-style: italic;
          font-weight: 600;
          color: #111827;
        ">
          ${relationPrefix}
          <b style="color:#1e40af;">
            ${student.parent_name || "________________"}
          </b>
        </p>

        <p style="
          font-size: 22px;
          line-height: 2.0;
          font-style: italic;
          font-weight: 600;
          text-align: center;
          margin: 0 auto;
          max-width: 900px;
          color: #111827;
        ">
          has been awarded the
          <b style="color:#ea580c;">${student.course_name}</b>
          diploma having successfully completed
          the prescribed curriculum from our
          center with grade
          <b style="color:#1e40af;">
            ${student.grade || "Excellent"}
          </b>.
        </p>

        <p style="
          font-size: 18px;
          font-style: italic;
          font-weight: 700;
          color: #111827;
        ">
          Certificate issued on:
          <span style="font-weight: 700;">
            ${issueDate}
          </span>
        </p>
      </div>

      <div class="info-row-certificate" style="
  font-size: 14px;
  font-weight: bold;
  margin-top: 8px;
">
        <span>
          Certificate No:
          <strong>${student.certificate_no || student.id || "-"}</strong>
        </span>
        <span>
          Roll No:
          <strong>${student.roll_no || "-"}</strong>
        </span>
      </div>
    `
    : `
      <!-- =========================================
           EXISTING LAYOUT FOR BOTH / MARKSHEET
           ========================================= -->
      <div class="content-text">
        This is to certify that
        <b>${student.full_name} ${relationPrefix} ${student.parent_name || ""}</b>
        has been awarded the
        <b>${student.course_name}</b>
        diploma having successfully completed the
        prescribed curriculum from our center with grade
        <b>${student.grade || "Excellent"}</b>.
      </div>

      <div class="info-row">
        <span>Certificate No: ${student.certificate_no || "-"}</span>
        <span>Roll No: ${student.roll_no || "-"}</span>
      </div>
    `
}

${
  !isCertificateOnly
    ? `
      <table class="marks-table">
        <thead>
          <tr>
            <th>Modules / Subjects</th>
            <th style="width:60px; text-align:center;">Max</th>
            <th style="width:60px; text-align:center;">Secured</th>
            <th style="width:195px;">Final Result</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="3">
              <table style="width:100%; border-collapse:collapse;" class="inner-row">
                ${modulesList
                  .map(
                    (name, i) => `
                  <tr>
                    <td style="width:75%; font-weight:bold; color:#444;">${name}</td>
                    <td style="width:12.5%; text-align:center; border-left:1px solid #ddd !important;">100</td>
                    <td style="width:12.5%; text-align:center; border-left:1px solid #ddd !important; font-weight:bold;">${marksArray[i] || 0}</td>
                  </tr>
                `,
                  )
                  .join("")}
              </table>
            </td>
            <td class="summary-panel">
              <b>Total Secured: ${totalSecured} / ${totalPossible}</b>
              <b>Percentage: ${percentage}%</b>
              <b>Result Status: PASS</b>
              <b>Awarded Grade: ${student.grade}</b>
              <div style="text-align:center; margin-top:20px;">
              <img
  style="width:110px;"
  src="https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent(verifyUrl)}"
/>
                <p style="font-size:8px; margin-top:5px; color:#7c2d12;">Scan to Verify</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    `
    : `
      <div style="
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
      ">
        <div style="
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-top: 0px;
        ">
          <div style="text-align:center;">
           <img
  style="width:110px;"
  src="https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent(verifyUrl)}"
/>
            <p style="font-size:9px; margin-top:6px; color:#7c2d12; font-weight:bold;">
              Scan to Verify
            </p>
          </div>

                </div>
    `
}
              <div class="${isCertificateOnly ? "footer-certificate" : "footer"}">
                <div class="seal-section">
                <img src="${STAMP_URL}" class="seal-img" alt="Institute Stamp" />
                <span>Issue Date: ${issueDate}</span>
                </div>

                <div class="sig-box">
                <img src="${SIGNATURE_URL}" class="${isCertificateOnly ? "sig-img-certificate" : "sig-img"}" alt="Director Signature" />
                  <div class="sig-space"></div> <div class="sig-line">Santosh Kumar Prajapati</div>
                  <div style="font-size:13px; color:#555; font-weight:bold;">(Director)</div>
                </div>
              </div>
            </div>

            <div class="grade-scale">
               <div class="scale-box" style="background: #1e3a8a;">Excellent: 80-100%</div>
               <div class="scale-box" style="background: #1e40af;">Good: 70-79.9%</div>
               <div class="scale-box" style="background: #1e3a8a;">Fair: 60-69.9%</div>
               <div class="scale-box" style="background: #1e40af;">Satisfactory: 50-59.9%</div>
            </div>
          </div>
        </div>
        <script>window.onload = function() { window.print(); window.close(); }</script>
      </body>
    </html>
  `);
  //   printWindow.document.close();
  printWindow.focus();
};
